import { render, staticRenderFns } from "./DescriptionPerformance.vue?vue&type=template&id=5d95ddbe&"
import script from "./DescriptionPerformance.vue?vue&type=script&lang=js&"
export * from "./DescriptionPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports